import VueRouter, { Route } from 'vue-router';
import { Store } from 'vuex';
import { ExperimentGetter, RootState } from 'frontend/types';
import { SPONSOR_PAGES } from 'frontend/utils/experiment';

/**
 * Pages after signing up via a marketing/sponsor landing page use the mlp=true GET param to
 * trigger special behavior
 */
export const MARKETING_LANDING_PAGES_GET_PARAM = 'mlp';

export function justSignedUpFromMarketingLandingPage(route: Route): boolean {
  return route.query[MARKETING_LANDING_PAGES_GET_PARAM] === 'true';
}

export function showShortNuxPaywall(route: Route, experimentGetter: ExperimentGetter): boolean {
  return (
    justSignedUpFromMarketingLandingPage(route) &&
    experimentGetter(SPONSOR_PAGES.EXPERIMENT, SPONSOR_PAGES.SHORT_PAYWALL_TREATMENT)
  );
}

export async function handleClosedNuxPaywallFromMarketingPage(
  store: Store<RootState>,
  router: VueRouter,
) {
  await router.push({ name: 'nux_welcome' });
  // Need to clear plans here so we don't re-show the paywall during the normal NUX flow
  store.dispatch('paywall/clearPlans');
}
